var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    transform: "translate(0 0.5)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.72818 5.70801L19.2699 5.70801C19.5739 5.81463 19.8114 6.05593 19.9133 6.36157C20.0152 6.66721 19.9699 7.0028 19.7907 7.27051L14.5824 12.9997V20.2913L10.4157 17.1663L10.4157 12.9997L5.20735 7.27051C5.02811 7.0028 4.98283 6.66721 5.08471 6.36157C5.18659 6.05593 5.42417 5.81463 5.72818 5.70801",
    stroke: "#4B465C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.72818 5.70801L19.2699 5.70801C19.5739 5.81463 19.8114 6.05593 19.9133 6.36157C20.0152 6.66721 19.9699 7.0028 19.7907 7.27051L14.5824 12.9997V20.2913L10.4157 17.1663L10.4157 12.9997L5.20735 7.27051C5.02811 7.0028 4.98283 6.66721 5.08471 6.36157C5.18659 6.05593 5.42417 5.81463 5.72818 5.70801",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.9e58fcb6b28b9c35d2a6a3be09eb3889.svg";
export { ForwardRef as ReactComponent };